import {axiosRequest} from "../api";
import {API_PATH} from "../../constants";

export const VaccineService = {
    getVaccinesList(params){ return axiosRequest('GET', API_PATH.VACCINE.LIST(params)) },
    getVaccine(data){ return axiosRequest('POST', API_PATH.VACCINE.INFO, data) },
    addVaccine(data){ return axiosRequest('POST', API_PATH.VACCINE.ADD, data) },
    deleteVaccine(data){ return axiosRequest('POST', API_PATH.VACCINE.DELETE, data) },
}